import { render, staticRenderFns } from "./SidebarSubmitSlot.vue?vue&type=template&id=e3dc0b76&"
import script from "./SidebarSubmitSlot.vue?vue&type=script&lang=js&"
export * from "./SidebarSubmitSlot.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSubmitSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports